module.exports = __webpack_public_path__ + "static/media/3797.edbbd4be.jpg";